export type OAuthFlowResult = { connectionId: string } | { error: string };

export const takeOAuthFlowResult = (): OAuthFlowResult | null => {
  const params = new URLSearchParams(window.location.hash.slice(1));
  const connectionId = params.get('connectionId');
  const error = params.get('error');
  if (!connectionId && !error) {
    return null;
  }
  window.history.replaceState(
    window.history.state,
    '',
    window.location.pathname + window.location.search,
  );
  return connectionId ? { connectionId } : { error: error as string };
};
